import { render, staticRenderFns } from "./CohortForm.vue?vue&type=template&id=03c72bd0"
import script from "./CohortForm.vue?vue&type=script&lang=js"
export * from "./CohortForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports